import React from "react";
import {getAllApplications} from "./applications/ApplicationsApi";
import {applicationsTableColumns} from "./applications/applicationsTableColumns";
import {useTranslation} from "react-i18next";
import {Application} from "./applications/Application";
import {useMediaQuery, useTheme} from "@mui/material";
import {StandardRole} from "./users/Role";
import {ContentPageTableHeader} from "../shared/components/tables/ContentPageTableHeader";
import {ContentPageTable} from "../shared/components/tables/ContentPageTable";
import {useAxios} from "../shared/technical/rest/AxiosProvider";
import {useQuery} from "react-query";
import {generatePath, useNavigate} from "react-router";
import {isEditableForRoles} from "../shared/technical/security/WithRestrictedEdit";
import {useAccount} from "./users/AccountProvider";
import {routePaths} from "../shared/components/router/routes";

export function ApplicationsPage() {
  const {t} = useTranslation();
  const account = useAccount();
  const theme = useTheme();
  const axios = useAxios();
  const navigate = useNavigate();
  const smallScreens = useMediaQuery(theme.breakpoints.down('sm'));
  const {data} = useQuery('applications', () => getAllApplications(axios), {});

  return (
    <>
      <ContentPageTableHeader onClick={() => navigate("/administration/applications/new")}
                              title={t('Application.titleLong')}
                              titleButton={t('Application.buttonCreate')}
                              isEditable={isEditableForRoles(account, [StandardRole.ADMIN])}
                              sx={{marginTop: 2}}
      />
      <ContentPageTable entities={data || []} columns={applicationsTableColumns(t, smallScreens)}
                        handleRowClick={(application: Application) => navigate(generatePath(routePaths.applicationWithId, {applicationId: application.id}))}/>
    </>
  );
}
